import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import * as cookiesettingsdata from 'src/app/cookie-settings/cookie-settings-data.json';
import * as menubardata from 'src/app/menu/menu-data.json';
import * as vmanicodeheaderadata from 'src/app/header/vmanicode-header/vmanicode-header-data.json';
import * as vmanicoriheaderadata from 'src/app/header/vmanicori-header/vmanicori-header-data.json';
import * as homepagedata from 'src/app/homepage/homepage-data.json';
import * as vmanicodehomepagedata from 'src/app/homepage/vmanicode-home/vmanicode-home-data.json';
import * as vmanicorihomepagedata from 'src/app/homepage/vmanicori-home/vmanicori-home-data.json';
import * as itchomepagedata from 'src/app/homepage/itc-home/itc-home-data.json';
import * as companypagedata from 'src/app/company/company-data.json';
import * as servicepagedata from 'src/app/delivery-services/delivery-services-data.json';
import * as productpagedata from 'src/app/product/product-data.json';
import * as solutionspagedata from 'src/app/product-solutions/product-solutions-data.json';
import * as platformpagedata from 'src/app/platform/platform-data.json';
import * as vmanicodepagedata from 'src/app/vmanicode/vmanicode-data.json';
import * as vmanicoripagedata from 'src/app/vmanicori/vmanicori-data.json';
import * as careerspagedata from 'src/app/careers/careers-data.json';
import * as blogspagedata from 'src/app/blogs/blogs-data.json';
import * as vmanicohelpsdata from 'src/app/vmanico-helps/vmanico-helps-data.json';
import * as aboutusdata from 'src/app/about-us/aboutus-data.json';
import * as contactusdata from 'src/app/contact-us-page/contact-us-data.json';
import * as footerdata from 'src/app/footer/footer-data.json';
import * as why from 'src/app/why-top-rated/why-top-rated-data.json'
import * as whatweare from 'src/app/whatareweoffering/whatareweoffering-data.json'
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ThemeService } from './themes.service';
import { API_ROUTES, SERVER_ENDPOINTS } from '../constants';

@Injectable({
    providedIn: 'root'
})

export class ApiService {

    headers: any;
    url = environment.AUTH_SERVICE_ENDPOINT;
    ipAddress: any;
    browserName: any;
    browserVersion: any;
    systemInformation: any;
    activeMenuTitle: string = '';
    accessToken: string;
    refreshToken: string;
    isApiServerWorking: boolean = true;
    userEndpoint: string = "";

    capturedUserImageSubject = new BehaviorSubject<any>("");
    capturedUserImage$: Observable<any> = this.capturedUserImageSubject.asObservable();

    userAccountDetailsSubject = new BehaviorSubject<any>(null);
    userAccountDetails$: Observable<any> = this.userAccountDetailsSubject.asObservable();

    navigateToHelpFormSubject = new BehaviorSubject<any>(false);
    navigateToHelpForm$: Observable<any> = this.navigateToHelpFormSubject.asObservable();

    keyboardActionsSubject = new BehaviorSubject<any>(false);
    keyboardActions$: Observable<any> = this.keyboardActionsSubject.asObservable();

    profileCheckSubject = new BehaviorSubject<any>(false);
    profileCheck$: Observable<any> = this.profileCheckSubject.asObservable();

    refreshProfileInformationSubject = new BehaviorSubject<any>(false);
    refreshProfileInformation$: Observable<any> = this.refreshProfileInformationSubject.asObservable();

    setActiveMenuTitle(title: string) {
        this.activeMenuTitle = title;
    }

    getActiveMenuTitle(): string {
        return this.activeMenuTitle;
    }

    constructor(
        private http: HttpClient,
        private router: Router,
        private cookieService: CookieService,
        private sanitizer: DomSanitizer,
        private themeService: ThemeService,
    ) {
        this.browserName = this.detectBrowserName();
        this.browserVersion = this.detectBrowserVersion();

        this.systemInformation = {
            ipAddress: this.ipAddress,
            browserName: this.browserName,
            browserVersion: this.browserVersion,
        };

        this.userEndpoint === window.location.hostname;
        this.themeService.selectedRegion$.subscribe((response) => {
            if (window.location.hostname === 'localhost') {
                if (response === "USA") {
                    this.userEndpoint = SERVER_ENDPOINTS.USA;
                } else if (response === "INDIA") {
                    this.userEndpoint = SERVER_ENDPOINTS.INDIA;
                }
            }
        });
    }

    // async getIpAddress() {
    //     const apiUrl = `${SERVER_ENDPOINTS.USA}${environment.IP_API_ENDPOINT}`;
    //     return this.http.get(apiUrl).toPromise();
    // }

    async getIpAddress() {
        // const apiUrl = `${environment.IP_API_ENDPOINT}`;
        // return this.http.get(apiUrl).toPromise();
        try {
            const response = await fetch(`${environment.IP_API_ENDPOINT}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch IP details: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error fetching IP details", error);
            throw error;
        }
    }



    detectBrowserName() {
        const agent = window.navigator.userAgent.toLowerCase()
        switch (true) {
            case agent.indexOf('edge') > -1:
                return 'edge';
            case agent.indexOf('opr') > -1 && !!(<any>window).opr:
                return 'opera';
            case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
                return 'chrome';
            case agent.indexOf('trident') > -1:
                return 'ie';
            case agent.indexOf('firefox') > -1:
                return 'firefox';
            case agent.indexOf('safari') > -1:
                return 'safari';
            default:
                return 'other';
        }
    }

    detectBrowserVersion() {
        let userAgent = navigator.userAgent, tem,
            matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        if (/trident/i.test(matchTest[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (matchTest[1] === 'Chrome') {
            tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
        return matchTest.join(' ');
    }

    getAccessToken() {
        return "";
    }

    getJSONFileData(filePath: string) {
        return this.http.get(filePath);
    }

    getCookieSettingsDataFromJSONFile(): Observable<any> {
        return of(cookiesettingsdata);
    }

    getMenubarDataFromJSONFile(): Observable<any> {
        return of(menubardata);
    }

    getVmanicodeHeaderDataFromJSONFile(): Observable<any> {
        return of(vmanicodeheaderadata);
    }

    getVmanicoriHeaderDataFromJSONFile(): Observable<any> {
        return of(vmanicoriheaderadata);
    }

    getHomePageDataFromJSONFile(): Observable<any> {
        return of(homepagedata);
    }

    getVmanicodeHomePageDataFromJSONFile(): Observable<any> {
        return of(vmanicodehomepagedata);
    }

    getVmanicoriHomePageDataFromJSONFile(): Observable<any> {
        return of(vmanicorihomepagedata);
    }

    getITCHomePageDataFromJSONFile(): Observable<any> {
        return of(itchomepagedata);
    }

    getwhatweare(): Observable<any> {
        return of(whatweare);
    }

    getServicePageDataFromJSONFile(): Observable<any> {
        return of(servicepagedata);
    }

    getCompanyPageDataFromJSONFile(): Observable<any> {
        return of(companypagedata);
    }

    getwhyPageDataFromJsonFile(): Observable<any> {
        return of(why);
    }

    getSolutionsPageDataFromJSONFile(): Observable<any> {
        return of(solutionspagedata);
    }

    getProductPageDataFromJSONFile(): Observable<any> {
        return of(productpagedata);
    }

    getPlatformPageDataFromJSONFile(): Observable<any> {
        return of(platformpagedata);
    }

    getVmanicodePageDataFromJSONFile(): Observable<any> {
        return of(vmanicodepagedata);
    }

    getVmanicoriPageDataFromJSONFile(): Observable<any> {
        return of(vmanicoripagedata);
    }

    getCareersPageDataFromJSONFile(): Observable<any> {
        return of(careerspagedata);
    }

    getBlogsPageDataFromJSONFile(): Observable<any> {
        return of(blogspagedata);
    }

    getAboutUsDataFromJSONFile(): Observable<any> {
        return of(aboutusdata);
    }

    getVamnicoHelpsDataFromJSONFile(): Observable<any> {
        return of(vmanicohelpsdata);
    }

    getContactUsDataFromJSONFile(): Observable<any> {
        return of(contactusdata);
    }

    getLeadershipPageDataFromJSONFile(): Observable<any> {
        return of(contactusdata);
    }

    getFooterDataFromJSONFile(): Observable<any> {
        return of(footerdata);
    }

    getHtmlTemplateFile(fileName: string) {
        return this.http.get(`assets/html-templates/${fileName}`, { responseType: 'text' });
    }

    getSafeUpdatedHtml(template: string, variables: { [key: string]: any }) {
        const updatedCode = template.replace(/\{\{(.*?)\}\}/g, (match, p1) => {
            return variables[p1.trim()];
        });

        return this.sanitizer.bypassSecurityTrustHtml(updatedCode);
    }

    getCountryCodesList() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.PUBLIC}${environment.API_VERSION}${API_ROUTES.COUNTRIES}`;
        return this.http.get(apiUrl);
    }

    getProvidersListByCountry(country: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.PUBLIC}${environment.API_VERSION}${API_ROUTES.PROVIDERS}/${country}`;
        return this.http.get(apiUrl);
    }

    registerUserWithDetails(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.REGISTRATION}${environment.API_VERSION}${API_ROUTES.REGISTER}`;
        return this.http.post(apiUrl, requestPayload);
    }

    loginWithEmailPasswordForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.LOGIN}${environment.API_VERSION}${API_ROUTES.USER_LOGIN}`;
        return this.http.post(apiUrl, requestPayload);
    }

    resendOtpForVerification(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.LOGIN}${environment.API_VERSION}${API_ROUTES.RESEND_OTP}`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    verifyOTPForAuthenticatedUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.LOGIN}${environment.API_VERSION}${API_ROUTES.VERIFY_OTP}`;
        return this.http.post(apiUrl, requestPayload);
    }

    changePasswordForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.CHANGE_PASSWORD}`;
        return this.http.put(apiUrl, requestPayload).toPromise();
    }

    forgotPasswordForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.FORGOT_PASSWORD}${environment.API_VERSION}${API_ROUTES.FORGOT_PASSWORD}`;
        return this.http.post(apiUrl, requestPayload);
    }

    resetPasswordForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.FORGOT_PASSWORD}${environment.API_VERSION}${API_ROUTES.VERIFY_OTP}`;
        return this.http.put(apiUrl, requestPayload).toPromise();
    }

    verifyForgotPasswordOTP(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.FORGOT_PASSWORD}${environment.API_VERSION}${API_ROUTES.VERIFY_FORGOT_PASSWORD}`;
        return this.http.post(apiUrl, requestPayload);
    }

    checkResetPasswordCode(requestPayload: any) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/auth/check-reset-code`;
        return this.http.post(apiUrl, requestPayload);
    }

    resetPasswordForUserByCode(requestPayload: any) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/auth/reset-password`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    getUserProfileImageUrl() {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/user/profile/image`;
        return this.http.get(apiUrl);
    }

    getImageViaUrl(imageUrl: string) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}${imageUrl}`;
        return this.http.get(apiUrl, { responseType: 'blob' });
    }

    refreshAccessToken() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.PUBLIC}${environment.API_VERSION}${API_ROUTES.REFRESH_TOKEN}`;
        return this.http.get(apiUrl);
    }

    refreshLoginForUser() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.REFRESH_LOGIN}`;
        return this.http.get(apiUrl);
    }

    getCareerJobsList(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.PUBLIC}${environment.API_VERSION}${API_ROUTES.SEARCH_REQUIREMENTS}`;
        return this.http.post(apiUrl, requestPayload);
    }

    getCareerJobDetailsByJobId(jobId: string) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.PUBLIC}${environment.API_VERSION}${API_ROUTES.JOB_DETAILS}${jobId}`;
        return this.http.get(apiUrl).toPromise();
    }

    applyForTheJob(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.JOB_APPLY}`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    callCustomAuthForServicesApp(redirectUrl: string) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/auth/custom-oauth?redirectUri=${redirectUrl}`;
        return this.http.get(apiUrl);
    }

    socialLogout() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.LOGIN}${environment.API_VERSION}${API_ROUTES.LOGOUT}`;
        return this.http.post(apiUrl, {}).toPromise();
    }

    logout() {
        this.cookieService.delete("userSelectedAccountDetails");
    }

    sendCookieConsentOfCustomer(requestPayload: any) {
        // const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/cookie-consent`;
        // return this.http.post(apiUrl, requestPayload);

        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.PUBLIC}${environment.API_VERSION}${API_ROUTES.GLOBAL_CONSENT}`;
        return this.http.post(apiUrl, requestPayload);
    }

    updateCookieConsentForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.PROFILE_CONSENT}`;
        return this.http.put(apiUrl, requestPayload).toPromise();
    }

    requestContactSupportFormForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.REGISTRATION}${environment.API_VERSION}${API_ROUTES.CONTACT_US}`;
        return this.http.post(apiUrl, requestPayload);
    }

    supportRequestFromUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.SUPPORT_REQUEST}`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    reportOutageFromUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.REPORT_OUTTAGE}`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    addSubscriptionForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.PROFILE_SUBSCRIPTION}`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    deleteSubscriptionForUser(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.PROFILE_SUBSCRIPTION}`;
        return this.http.delete(apiUrl, requestPayload);
    }

    requestEmailSubscriptionForUser(requestPayload: any) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/email-subscription/subscribe`;
        return this.http.post(apiUrl, requestPayload).toPromise();
    }

    acceptInvitation(invitationCode: string) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/auth/invite/${invitationCode}`;
        return this.http.get(apiUrl).toPromise();
    }

    getUserAccountDetails() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.PROFILE}`;
        return this.http.get(apiUrl).toPromise();
    }

    getFullUserAccountDetails() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.DETAILED_PROFILE}`;
        return this.http.get(apiUrl).toPromise();
    }

    getMyRoleOnPortal() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.ROLE}`;
        return this.http.get(apiUrl).toPromise();
    }

    getUserRoles() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.V360}${environment.API_VERSION}${API_ROUTES.ROLES_LIST}`;
        return this.http.get(apiUrl).toPromise();
    }

    getBrouchureFile(fileName: string) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.V360}${environment.API_VERSION}${API_ROUTES.BROUCHER}${fileName}`;
        return this.http.get(apiUrl, { responseType: 'blob' });
    }

    uploadUserProfileImage(requestPayload: any) {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.PROFILE_IMAGE}`;
        return this.http.post(apiUrl, requestPayload);
    }

    getUserProfileImage() {
        const apiUrl = `${this.userEndpoint}${environment.API_TYPE.AUTHENTICATED}${environment.API_VERSION}${API_ROUTES.PROFILE_IMAGE}`;
        return this.http.get(apiUrl, { responseType: 'blob' });
    }

    getMyAccountDetails() {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/auth/me`;
        return this.http.get(apiUrl).toPromise();
    }

    getMyCompanyDetails() {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/company/me`;
        return this.http.get(apiUrl).toPromise();
    }

    getAcknowledgementsList() {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/acknowledgement/all`;
        return this.http.get(apiUrl);
    }

    getAcknowledgmentByActionId(actionId: string) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/acknowledgement/${actionId}`;
        return this.http.get(apiUrl);
    }

    getAvailableProductsList() {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}/product`;
        return this.http.get(apiUrl, { 'headers': this.headers }).toPromise();
    }

    uploadFile(requestPayload: any) {
        const apiUrl = `${environment.AUTH_SERVICE_ENDPOINT}api/namespace/single`;
        return this.http.post(apiUrl, requestPayload, { 'headers': this.headers }).toPromise();
    }
}
